/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'estate': {
    width: 16,
    height: 16,
    viewBox: '0 0 24.05 22.37',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" _fill="#df4545" d="M8.8 18.5H4.3V9.06H0L11.19 0l11.2 9.06h-4.3v2.38H8.8v7.06z"/><path pid="1" _fill="none" _stroke="#df4545" stroke-linecap="round" stroke-linejoin="round" d="M18.27 21.87h-5.72V11.04h11v6.59"/><path pid="2" _fill="#df4545" d="M23.55 18.89H20v3.44l3.55-3.44z"/><path pid="3" _fill="none" _stroke="#df4545" stroke-linecap="round" stroke-linejoin="round" d="M15.12 14.1h5.59M15.12 17h5.59"/></g></g>'
  }
})
